import { useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import { Spinner } from '@/components/ui/spinner';
import { useClub } from '../ClubContext';
import { getClubTutorialLessons } from '../constants/clubTutorialLessons';
import { useClubTutorialProgress } from '../hooks/useClubTutorialProgress';

/**
 * Home do gestor: tutorial até concluir todas as lições; depois, dashboard.
 * Usado na rota índice `/clube` (inclui o redirect pós-login).
 */
export default function ClubHomeRedirect() {
    const { club, hasResale, isReseller, hasBenefits, canViewFinance } = useClub();
    const lessonIds = useMemo(
        () =>
            getClubTutorialLessons({ hasResale, hasPlans: isReseller || hasBenefits, canViewFinance }).map(
                lesson => lesson.id,
            ),
        [hasResale, isReseller, hasBenefits, canViewFinance],
    );
    const { allCompleted } = useClubTutorialProgress(lessonIds);

    if (!club?.id) {
        return (
            <div className="flex flex-1 items-center justify-center p-8">
                <Spinner className="size-6" />
            </div>
        );
    }

    return <Navigate to={allCompleted ? '/clube/dashboard' : '/clube/tutorial'} replace />;
}
